"use client";

import DisplayCards from "./display-cards";
import { Sparkles, Calendar, MessageSquare, BarChart2 } from "lucide-react";

const defaultCards = [
  {
    icon: <Sparkles className="h-4 w-4 text-indigo-300" />,
    title: "Smart Content Creation",
    description: "AI-powered content suggestions",
    date: "Just now",
    iconClassName: "text-indigo-500",
    titleClassName: "text-indigo-500 dark:text-indigo-400",
    className:
      "[grid-area:stack] hover:-translate-y-10 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-gray-200 dark:before:outline-gray-700 before:h-[100%] before:content-[''] before:bg-blend-overlay before:bg-white/50 dark:before:bg-dark-800/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration-700 hover:grayscale-0 before:left-0 before:top-0",
  },
  {
    icon: <Calendar className="h-4 w-4 text-blue-300" />,
    title: "Intelligent Scheduling",
    description: "Optimize posting times",
    date: "2 days ago",
    iconClassName: "text-blue-500",
    titleClassName: "text-blue-500 dark:text-blue-400",
    className:
      "[grid-area:stack] translate-x-12 translate-y-10 hover:-translate-y-1 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-gray-200 dark:before:outline-gray-700 before:h-[100%] before:content-[''] before:bg-blend-overlay before:bg-white/50 dark:before:bg-dark-800/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration-700 hover:grayscale-0 before:left-0 before:top-0",
  },
  {
    icon: <BarChart2 className="h-4 w-4 text-purple-300" />,
    title: "Advanced Analytics",
    description: "Track performance metrics",
    date: "Today",
    iconClassName: "text-purple-500",
    titleClassName: "text-purple-500 dark:text-purple-400",
    className:
      "[grid-area:stack] translate-x-24 translate-y-20 hover:translate-y-10",
  },
];

function DisplayCardsDemo() {
  return (
    <div className="flex min-h-[400px] w-full items-center justify-center py-20">
      <div className="w-full max-w-3xl">
        <DisplayCards cards={defaultCards} />
      </div>
    </div>
  );
}

export { DisplayCardsDemo };